import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngxs/store';
import { of } from 'rxjs';
import { catchError, repeat, tap } from 'rxjs/operators';
import { AvailabilityStatus } from './../../../../../../../../_shared/enums/treatment/availabilityStatus.enum';
import { TreatmentGUI } from './../../../../../../../../_shared/model/treatment/treatmentGUI.model';
import { HelperNavigateService } from './../../../../../../../../_shared/services/helper-navigate.service';
import { Term } from './../../../../../../../../_shared/state/treatment/treatment.actions';
import { TreatmentState } from './../../../../../../../../_shared/state/treatment/treatment.state';

@Component({
    selector: 'trt-wid-m-term-head',
    templateUrl: './trt-wid-m-term-head.component.html',
    styles: [],
})
export class TrtWidMTermHeadComponent implements OnInit {
    // @Input()
    // public resRequestData: TreatmentReservationRequest;

    @Input()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public formData: any;

    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    public onClosePopup = new EventEmitter();

    public treatment: TreatmentGUI;
    public isLoadingTermChecking = false;
    public availabilityStatus: typeof AvailabilityStatus = AvailabilityStatus;

    constructor(
        public store: Store,
        public helperNavigate: HelperNavigateService,
    ) {}

    ngOnInit() {
        this.treatment = this.store.selectSnapshot(TreatmentState.treatmentData);
    }

    public checkTermAvailability(): void {
        this.store
            .dispatch(new Term.CheckTermAvailability(this.formData?.internalId))
            .pipe(
                repeat(1),
                tap(() => (this.isLoadingTermChecking = false)),
                catchError(err => {
                    this.isLoadingTermChecking = false;
                    return of(err);
                }),
            )
            .subscribe();
    }

    public openReservation(): void {
        this.onClosePopup.emit();
        this.helperNavigate.navigateToVisitPrereservation(this.formData.prereservationId);
    }

    public toggleExpand(): void {
        this.store.dispatch(new Term.ToggleDetails(this.formData?.internalId));
    }

    public removeTerm(): void {
        this.store.dispatch(new Term.RemoveTerm(this.formData?.internalId));
    }

    public makeReservatonForSingle(): void {
        this.store.dispatch(new Term.CreateNewReservations([this.formData?.internalId])).subscribe();
    }

    public removeReservation(): void {
        this.store.dispatch(new Term.DeleteTermReservation(this.formData?.internalId));
    }

    public updateReservatonForSingle(): void {
        this.store.dispatch(new Term.UpdateReservations([this.formData?.internalId])).subscribe();
    }
}
